import { useEffect, useState } from 'react'

interface AnimatedMetricsProps {
  heading: string
  value: number
  animateInMs?: number
  containerStyle?: string
}

const AnimatedMetrics = ({
  heading,
  value,
  animateInMs = 1000,
  containerStyle,
}: AnimatedMetricsProps) => {
  const [updatedCount, setUpdatedCount] = useState(0)

  useEffect(() => {
    if (animateInMs > 0) {
      const perMilliSecondIncrement = value / animateInMs
      for (let i = 0; i < animateInMs; i++) {
        setTimeout(
          () => setUpdatedCount(Math.round(perMilliSecondIncrement * (i + 1))),
          i
        )
      }
    } else {
      setUpdatedCount(value)
    }
  }, [value, animateInMs])

  return (
    <article className={containerStyle}>
      <p className="font-natosans-bold text-[#222222] text-[25px]">
        {updatedCount}
      </p>
      <p className="font-robot-medium text-[#6bb51e] py-[5px] text-base">
        {heading}
      </p>
    </article>
  )
}

export default AnimatedMetrics
